import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CalendarIcon, UsersIcon, ClockIcon, CheckIcon, ChevronDownIcon } from 'lucide-react';
export function ReservationPage({
  onBack
}: {
  onBack: () => void;
}) {
  const [step, setStep] = useState<1 | 2 | 3>(1);
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [partySize, setPartySize] = useState('');
  const [occasion, setOccasion] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [requests, setRequests] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [confirmationCode, setConfirmationCode] = useState('');
  const times = ['9:00 PM', '9:30 PM', '10:00 PM', '10:30 PM', '11:00 PM', '11:30 PM', '12:00 AM', '12:30 AM', '1:00 AM'];
  const occasions = ['Birthday', 'Anniversary', 'Bachelor/Bachelorette', 'Corporate Event', 'Date Night', 'Just for Fun'];
  const handleSubmit = () => {
    setIsProcessing(true);
    setTimeout(() => {
      setConfirmationCode(`RES-${Date.now().toString(36).toUpperCase().slice(-6)}`);
      setStep(3);
      setIsProcessing(false);
    }, 1800);
  };
  const step1Valid = date && time && partySize;
  const step2Valid = name && email && phone;
  return <div className="min-h-screen w-full bg-[#050505] pt-24 pb-20 px-4 sm:px-6" data-id="element-1124">
      <div className="max-w-2xl mx-auto" data-id="element-1125">
        {/* Back */}
        <motion.button initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.4
      }} onClick={onBack} className="flex items-center gap-2 font-montserrat text-[12px] tracking-widest text-white/40 hover:text-[#C9A84C] transition-colors duration-300 mb-10" data-id="element-1126">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" data-id="element-1127">
            <path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1128" />
          </svg>
          BACK TO HOME
        </motion.button>

        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-1129">
          <span className="font-inter text-[13px] tracking-[0.4em] text-[#C9A84C]/60 uppercase" data-id="element-1130">
            MK LOUNGE ON U
          </span>
          <h1 className="font-montserrat font-black text-4xl sm:text-5xl tracking-widest text-white mt-2" data-id="element-1131">
            RESERVATIONS
          </h1>
          <div className="w-14 h-px bg-[#C9A84C]/50 mx-auto mt-4" data-id="element-1132" />
        </motion.div>

        {/* Step indicator */}
        {step < 3 && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="flex items-center justify-center gap-3 mb-10" data-id="element-1133">
            {[1, 2].map(s => <div key={s} className="flex items-center gap-3" data-id="element-1134">
                <div className="w-8 h-8 rounded-full flex items-center justify-center font-montserrat font-black text-[13px] transition-all duration-300" style={{
            background: step >= s ? '#C9A84C' : 'rgba(201,168,76,0.1)',
            color: step >= s ? '#050505' : 'rgba(201,168,76,0.4)',
            border: step >= s ? 'none' : '1px solid rgba(201,168,76,0.2)'
          }} data-id="element-1135">
                  {step > s ? <CheckIcon size={14} data-id="element-1136" /> : s}
                </div>
                <span className="font-montserrat text-[11px] tracking-widest" style={{
            color: step >= s ? '#C9A84C' : 'rgba(255,255,255,0.25)'
          }} data-id="element-1137">
                  {s === 1 ? 'DETAILS' : 'CONTACT'}
                </span>
                {s < 2 && <div className="w-12 h-px" style={{
            background: step > s ? '#C9A84C' : 'rgba(201,168,76,0.2)'
          }} data-id="element-1138" />}
              </div>)}
          </motion.div>}

        <AnimatePresence mode="wait" data-id="element-1139">
          {/* Step 1 */}
          {step === 1 && <motion.div key="step1" initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -30
        }} transition={{
          duration: 0.25
        }} className="rounded-3xl p-7 sm:p-9" style={{
          background: '#0d0b09',
          border: '1px solid #2A2622',
          boxShadow: '0 8px 40px rgba(0,0,0,0.6)'
        }} data-id="element-1140">
              <h2 className="font-montserrat font-black text-xl tracking-widest text-white mb-7" data-id="element-1141">
                VISIT DETAILS
              </h2>
              <div className="flex flex-col gap-5" data-id="element-1142">
                {/* Date */}
                <div data-id="element-1143">
                  <label className="font-inter text-[12px] text-white/40 mb-2 block tracking-widest" data-id="element-1144">
                    DATE
                  </label>
                  <div className="relative" data-id="element-1145">
                    <CalendarIcon size={15} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#C9A84C] pointer-events-none" data-id="element-1146" />
                    <input type="date" value={date} onChange={e => setDate(e.target.value)} className="w-full bg-white/5 border border-[#2A2622] rounded-xl pl-11 pr-4 py-3.5 text-[16px] text-white/80 font-inter focus:outline-none focus:border-[#C9A84C]/50 transition-colors [color-scheme:dark]" data-id="element-1147" />
                  </div>
                </div>

                {/* Time */}
                <div data-id="element-1148">
                  <label className="font-inter text-[12px] text-white/40 mb-2 block tracking-widest" data-id="element-1149">
                    ARRIVAL TIME
                  </label>
                  <div className="grid grid-cols-3 gap-2" data-id="element-1150">
                    {times.map(t => <button key={t} onClick={() => setTime(t)} className="py-2.5 rounded-xl font-inter text-[13px] transition-all duration-200" style={{
                  background: time === t ? '#C9A84C' : 'rgba(255,255,255,0.04)',
                  color: time === t ? '#050505' : 'rgba(255,255,255,0.55)',
                  border: time === t ? 'none' : '1px solid #2A2622',
                  fontWeight: time === t ? 700 : 400
                }} data-id="element-1151">
                        {t}
                      </button>)}
                  </div>
                </div>

                {/* Party size */}
                <div data-id="element-1152">
                  <label className="font-inter text-[12px] text-white/40 mb-2 block tracking-widest" data-id="element-1153">
                    PARTY SIZE
                  </label>
                  <div className="relative" data-id="element-1154">
                    <UsersIcon size={15} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#C9A84C] pointer-events-none z-10" data-id="element-1155" />
                    <select value={partySize} onChange={e => setPartySize(e.target.value)} className="w-full bg-white/5 border border-[#2A2622] rounded-xl pl-11 pr-4 py-3.5 text-[16px] text-white/80 font-inter focus:outline-none focus:border-[#C9A84C]/50 transition-colors appearance-none cursor-pointer" style={{
                  background: 'rgba(13,11,9,0.9)'
                }} data-id="element-1156">
                      <option value="" style={{
                    background: '#0d0b09'
                  }} data-id="element-1157">
                        Select party size
                      </option>
                      {['1', '2', '3', '4', '5', '6', '7-10', '10-15', '15-20', '20+'].map(n => <option key={n} value={n} style={{
                    background: '#0d0b09'
                  }} data-id="element-1158">
                          {n} {n === '1' ? 'Guest' : 'Guests'}
                        </option>)}
                    </select>
                  </div>
                </div>

                {/* Occasion */}
                <div data-id="element-1159">
                  <label className="font-inter text-[12px] text-white/40 mb-2 block tracking-widest" data-id="element-1160">
                    OCCASION (OPTIONAL)
                  </label>
                  <div className="flex flex-wrap gap-2" data-id="element-1161">
                    {occasions.map(o => <button key={o} onClick={() => setOccasion(occasion === o ? '' : o)} className="px-4 py-2 rounded-xl font-inter text-[13px] transition-all duration-200" style={{
                  background: occasion === o ? 'rgba(201,168,76,0.15)' : 'rgba(255,255,255,0.04)',
                  color: occasion === o ? '#C9A84C' : 'rgba(255,255,255,0.45)',
                  border: occasion === o ? '1px solid rgba(201,168,76,0.4)' : '1px solid #2A2622'
                }} data-id="element-1162">
                        {o}
                      </button>)}
                  </div>
                </div>
              </div>

              <button onClick={() => step1Valid && setStep(2)} disabled={!step1Valid} className="w-full mt-8 font-montserrat font-black text-[13px] tracking-widest py-4 rounded-xl transition-all duration-300" style={{
            background: step1Valid ? '#C9A84C' : 'rgba(201,168,76,0.2)',
            color: step1Valid ? '#050505' : 'rgba(201,168,76,0.4)',
            cursor: step1Valid ? 'pointer' : 'not-allowed'
          }} data-id="element-1163">
                CONTINUE
              </button>
            </motion.div>}

          {/* Step 2 */}
          {step === 2 && <motion.div key="step2" initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -30
        }} transition={{
          duration: 0.25
        }} className="rounded-3xl p-7 sm:p-9" style={{
          background: '#0d0b09',
          border: '1px solid #2A2622',
          boxShadow: '0 8px 40px rgba(0,0,0,0.6)'
        }} data-id="element-1164">
              {/* Summary bar */}
              <div className="flex items-center gap-3 mb-7 p-4 rounded-2xl" style={{
            background: 'rgba(201,168,76,0.06)',
            border: '1px solid rgba(201,168,76,0.15)'
          }} data-id="element-1165">
                <button onClick={() => setStep(1)} className="text-[#C9A84C]/60 hover:text-[#C9A84C] transition-colors" data-id="element-1166">
                  <svg width="14" height="14" viewBox="0 0 16 16" fill="none" data-id="element-1167">
                    <path d="M10 3L5 8l5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-1168" />
                  </svg>
                </button>
                <div className="flex gap-4 text-[13px] font-inter text-white/60" data-id="element-1169">
                  <span data-id="element-1170">{date}</span>
                  <span className="text-[#C9A84C]/40" data-id="element-1171">·</span>
                  <span data-id="element-1172">{time}</span>
                  <span className="text-[#C9A84C]/40" data-id="element-1173">·</span>
                  <span data-id="element-1174">{partySize} guests</span>
                </div>
              </div>

              <h2 className="font-montserrat font-black text-xl tracking-widest text-white mb-7" data-id="element-1175">
                YOUR DETAILS
              </h2>
              <div className="flex flex-col gap-4" data-id="element-1176">
                {[{
              label: 'FULL NAME',
              value: name,
              setter: setName,
              placeholder: 'Your full name',
              type: 'text'
            }, {
              label: 'EMAIL ADDRESS',
              value: email,
              setter: setEmail,
              placeholder: 'your@email.com',
              type: 'email'
            }, {
              label: 'PHONE NUMBER',
              value: phone,
              setter: setPhone,
              placeholder: '+1 (555) 000-0000',
              type: 'tel'
            }].map(field => <div key={field.label} data-id="element-1177">
                    <label className="font-inter text-[12px] text-white/40 mb-1.5 block tracking-widest" data-id="element-1178">
                      {field.label}
                    </label>
                    <input type={field.type} value={field.value} onChange={e => field.setter(e.target.value)} placeholder={field.placeholder} className="w-full bg-white/5 border border-[#2A2622] rounded-xl px-4 py-3.5 text-[16px] text-white/80 font-inter focus:outline-none focus:border-[#C9A84C]/50 transition-colors placeholder:text-white/20" data-id="element-1179" />
                  </div>)}
                <div data-id="element-1180">
                  <label className="font-inter text-[12px] text-white/40 mb-1.5 block tracking-widest" data-id="element-1181">
                    SPECIAL REQUESTS (OPTIONAL)
                  </label>
                  <textarea value={requests} onChange={e => setRequests(e.target.value)} placeholder="Any special requests or notes..." rows={3} className="w-full bg-white/5 border border-[#2A2622] rounded-xl px-4 py-3.5 text-[16px] text-white/80 font-inter focus:outline-none focus:border-[#C9A84C]/50 transition-colors placeholder:text-white/20 resize-none" data-id="element-1182" />
                </div>
              </div>

              <button onClick={handleSubmit} disabled={!step2Valid || isProcessing} className="w-full mt-7 font-montserrat font-black text-[13px] tracking-widest py-4 rounded-xl transition-all duration-300 flex items-center justify-center gap-2" style={{
            background: step2Valid ? '#C9A84C' : 'rgba(201,168,76,0.2)',
            color: step2Valid ? '#050505' : 'rgba(201,168,76,0.4)',
            cursor: step2Valid ? 'pointer' : 'not-allowed',
            opacity: isProcessing ? 0.8 : 1
          }} data-id="element-1183">
                {isProcessing ? <>
                    <motion.div animate={{
                rotate: 360
              }} transition={{
                duration: 1,
                repeat: Infinity,
                ease: 'linear'
              }} className="w-4 h-4 border-2 border-[#050505]/30 border-t-[#050505] rounded-full" data-id="element-1184" />
                    CONFIRMING...
                  </> : 'CONFIRM RESERVATION'}
              </button>
            </motion.div>}

          {/* Step 3 — Confirmation */}
          {step === 3 && <motion.div key="step3" initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.4,
          ease: [0.22, 1, 0.36, 1]
        }} className="rounded-3xl p-9 flex flex-col items-center text-center" style={{
          background: '#0d0b09',
          border: '1px solid rgba(201,168,76,0.25)',
          boxShadow: '0 0 60px rgba(201,168,76,0.08), 0 8px 40px rgba(0,0,0,0.6)'
        }} data-id="element-1185">
              <motion.div initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} transition={{
            delay: 0.2,
            type: 'spring',
            stiffness: 300,
            damping: 20
          }} className="w-20 h-20 rounded-full flex items-center justify-center mb-6" style={{
            background: '#C9A84C',
            boxShadow: '0 0 50px rgba(201,168,76,0.4)'
          }} data-id="element-1186">
                <CheckIcon size={36} className="text-[#050505]" data-id="element-1187" />
              </motion.div>
              <motion.h2 initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3
          }} className="font-montserrat font-black text-3xl tracking-widest text-white mb-2" data-id="element-1188">
                YOU'RE BOOKED!
              </motion.h2>
              <motion.p initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4
          }} className="font-inter text-[16px] text-white/50 mb-8 leading-relaxed" data-id="element-1189">
                Your reservation at MK Lounge on U has been confirmed. We'll see
                you soon!
              </motion.p>

              <motion.div initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.45
          }} className="w-full rounded-2xl p-5 mb-6 text-left" style={{
            background: 'rgba(201,168,76,0.06)',
            border: '1px solid rgba(201,168,76,0.2)'
          }} data-id="element-1190">
                <div className="grid grid-cols-2 gap-3" data-id="element-1191">
                  {[{
                label: 'NAME',
                value: name
              }, {
                label: 'DATE',
                value: date
              }, {
                label: 'TIME',
                value: time
              }, {
                label: 'PARTY SIZE',
                value: `${partySize} guests`
              }].map(item => <div key={item.label} data-id="element-1192">
                      <p className="font-montserrat text-[10px] tracking-widest text-[#C9A84C]/60 mb-0.5" data-id="element-1193">
                        {item.label}
                      </p>
                      <p className="font-inter text-[14px] text-white/80" data-id="element-1194">
                        {item.value}
                      </p>
                    </div>)}
                </div>
                <div className="h-px bg-[#2A2622] my-4" data-id="element-1195" />
                <div className="text-center" data-id="element-1196">
                  <p className="font-montserrat text-[10px] tracking-widest text-white/30 mb-1" data-id="element-1197">
                    CONFIRMATION CODE
                  </p>
                  <p className="font-montserrat font-black text-xl tracking-[0.3em] text-[#C9A84C]" data-id="element-1198">
                    {confirmationCode}
                  </p>
                </div>
              </motion.div>

              <motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.55
          }} className="font-inter text-[14px] text-white/35 leading-relaxed mb-6" data-id="element-1199">
                A confirmation has been sent to{' '}
                <span className="text-white/60" data-id="element-1200">{email}</span>. Please arrive 15
                minutes early.
              </motion.p>

              <motion.button initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.6
          }} onClick={onBack} className="font-montserrat font-black text-[13px] tracking-widest bg-[#C9A84C] text-[#050505] px-10 py-4 rounded-xl hover:bg-[#E8C97A] transition-colors duration-300" data-id="element-1201">
                BACK TO HOME
              </motion.button>
            </motion.div>}
        </AnimatePresence>
      </div>
    </div>;
}